import { useAnimation } from "framer-motion";
import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { backendTechStack } from "../../config/TechStatckData/backendTechStack";
import { frontendTechStack } from "../../config/TechStatckData/frontendTechStack";
import { hosting } from "../../config/TechStatckData/hosting";
import HorizontalLine from "../HorizontalLine";

import "./skill.css";

import Carousel from "../Carousel/Carousel";
import TitleCarousel from "../Carousel/TitleCarousel";

const Skill = ({ skillRef }) => {
  const { ref, inView } = useInView({ thresold: 0.1 });
  const animation = useAnimation();
  useEffect(() => {
    if (inView) {
      animation.start({
        opacity: 1,
        x: 0,
        width: "100%",
        transition: {
          ease: "easeInOut",
          duration: 1,
          delay: 0.2,
        },
      });
    } else {
      animation.start({
        opacity: 1,
        width: 0,
      });
    }
  }, [inView]);

  return (
    <div
      ref={skillRef}
      className="pt-40 px-2 lg:px-20 space-y-8 "
      
    >
      <div>
        <HorizontalLine section={"Skill"} />
      </div>

      <div
        
        className="border bg-black bg-opacity-50 py-5 rounded-md border-gray-900 space-y-10 shadow-2xl shadow-blue-300">
        <div className="px-10 py-5 space-y-5 ">
         
          <TitleCarousel direction={"ltr"} title={"Fontend"} />
          <Carousel data={frontendTechStack} direction="ltr" />
        </div>
        <div className="px-10 py-5 space-y-5">
          <TitleCarousel title={"Backend"} direction="rtl"/>
          <Carousel data={backendTechStack} direction="rtl"/>
        </div>

        <div className="px-10 py-5 space-y-5">
          <TitleCarousel title={"Hosting Platform"} directions="ltr" />
          <Carousel data={hosting} direction="ltr"/>
        </div>
      </div>
    </div>
  );
};

export default Skill;
